<template>
  <van-popup
    v-model="maoDialog"
    round
    position="bottom"
    class="popup"
  >
    <div class="popup-top">
      <p class="popup-top-content">{{maoData.titleMain}}<span class="pl30">借款<span class="red">少还{{maoData.svipCouponDiscountPrice}}</span>元</span></p>
      <img src="./images/btn_close@2x.png" class="popup-top-img" @click="close"/>
    </div>
    <p class="popup-content">{{maoData.notice}}</p>
    <div class="popup-main">
      <div v-for="(item,index) in bannerList" :key="index" class="popup-item">
        <img class="popup-item-img" :src="item.imageUrl"/>
        <p class="popup-item-title" v-html="item.desc"></p>
      </div>
    </div>
    <div class="popup-foot">
      <span class="ui-bubble" v-if="maoData.endTime && (new Date(maoData.endTime).getTime() - new Date().getTime() >0)">
        <van-count-down
          :time="new Date(maoData.endTime).getTime() - new Date().getTime()"
          format="DD天HH时mm分"
        />
      </span>
      <nd-button class="popup-foot-btn" @click="judgeOrder(maoData)">优惠价 ¥{{maoData.discountPrice}}<span class="through">原价 ¥{{maoData.price}}</span></nd-button>
      <p class="popup-foot-content">开通即同意<span @click="routerToVipProtocol" class="blue">《会员用户协议》</span></p>
    </div>
  </van-popup>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      maoData: {},
      maoDialog: false
    }
  },
  computed: {
    bannerList () {
      return this.maoData.bannerList || []
    }
  },
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions('withdraw', [
      'buySvipPopup'
    ]),
    judgeOrder (mao) {
      this.$emit('judgeOrder', mao)
    },
    // 关闭
    close () {
      this.maoDialog = false
    },
    // 弹窗
    async showMao () {
      const response = await this.buySvipPopup()
      if (response.success) {
        this.maoData = response.data.popup || {}
        this.maoDialog = true
      }
    },
    routerToVipProtocol () {
      this.$report({
        id: 10019,
        args: { position: 1 }
      })
      this.close()
      this.$router.push('/protocol/vip')
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/less/mixin.less";

.pl30{
    padding-left:30px;
}
.popup{
      background: #FAFAFA;
      .through{
            text-decoration: line-through;
            margin-left:14px;
            font-size: 28px;
        }
    .popup-top{
        padding:50px 30px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .red{
            color:#FF4633
        }
        &-content{
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
        }
        &-img{
            width:32px;
            height:32px;
        }
    }
    &-content{
        padding:5px 30px 0 30px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
    }
    &-main{
        padding:0 30px;
        margin-top:40px;
        display: flex;
        justify-content:space-between;
        .popup-item{
            width: 220px;
            padding:29px 5px 18px;
            background: #FFFFFF;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 30px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align:center;
            &-img{
                width:64px;
                height:64px;
            }
            &-title{
                margin-top:21px;
            }
        }
    }
    &-foot{
        margin-top:20px;
        padding-top:20px;
        width: 750px;
        height: 230px;
        background: #FFFFFF;
        box-shadow: 0px -10px 20px 0px rgba(0, 0, 0, 0.05);
        position:relative;
        /deep/ .van-count-down{
            position:absolute;
            top:17px;
            right:120px;
            padding:6px 14px;
            background: linear-gradient(90deg, #FF5F34 0%, #FF3333 100%);
            border-radius: 20px 20px 20px 0px;
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFD8BC;
            line-height: 28px;
            display: flex;
            align-items:center;
            justify-content:center;
        }
        &-btn{
            width: 670px;
            height: 94px;
            margin:auto;
            background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
            border-radius: 47px;
            font-size: 36px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763E12;
        }
        &-content{
            margin-top:25px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 33px;
            text-align: center;
        }
        .blue{
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #8EB2D8;
            line-height: 33px;
        }
    }
  }
  .dialog{
        position: relative;
        .huang-guan{
          position: absolute;
          background: url('./images/img_0@2x.png');
          background-size:cover;
          width:420px;
          height:136px;
          top:-134px;
          left:106px;
        }
        &-top{
        width: 620px;
        height: 153px;
        background: linear-gradient(90deg, #FCD5AC 0%, #FEF6E4 100%);
        border-radius: 30px;
        padding-top:40px;
        margin-top:-40px;
        text-align: center;
        .success{
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #763E12;
        }
        .ji-huo{
            font-size: 24px;
            color: #763E12;
            padding-top:5px;
        }
        }
        &-center{
        display: flex;
        justify-content:space-between;
        width: 444px;
        margin:30px auto 0;
        &-left,&-right{
            display: flex;
            flex-direction: column;
            align-items:center;
            width: 207px;
            height: 167px;
            background: #FFF7E5;
            border-radius: 14px;
            padding-top:25px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            >img{
            width:80px;
            height:80px;
            }
            >p{
            margin-top:15px;
            font-size: 24px;
            color: #763E12;
            }
        }
        }
        &-bottom{
        display: flex;
        justify-content:space-between;
        margin-bottom: 50px;
        .dialog-white,.dialog-red{
            width: 270px;
            line-height: 80px;
            height: 80px;
            margin:50px auto 0;
            border-radius: 47px;
            text-align: center;
            font-size: 30px;
        }
        .dialog-white{
                border: 1px solid #FF4633;
                color: #FF4633;
                background:white;
            }
            .dialog-red{
                background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
                color: #FFFFFF;
            }
        }
  }
</style>